import React from "react";
import "../../styling/pageStyling/home.css";
import { Link } from "react-router-dom";

function NewFaqs() {
  return (
    <>
      <div className="grid grid-cols-1 max-w-[1150px] mx-auto px-4 gap-3 last:[&>div]:mb-5 ">
        <div className="collapse collapse-plus bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] px-[3px] pb-[3px] overflow-hidden rounded-[10px]  ">
          <input type="checkbox" name="my-accordion-3" />
          <div className="collapse-title CustomCardHead CustomAfter  text-[#030021]    ">
            How is SPONSA different from other tipping platforms?
          </div>
          <div className="collapse-content bg-[#030021] rounded-[10px]    ">
            <p className="CustomCardPara text-white mt-4">
              We’re the only platform that allows creators to set up and collect
              tips for multiple projects/goals simultaneously. As creators
              ourselves, we know you’re likely cooking up a bunch of stuff at
              the same time! We’re here to help you.
            </p>
          </div>
        </div>
        <div className="collapse collapse-plus bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] px-[3px] pb-[3px] overflow-hidden rounded-[10px] ">
          <input type="checkbox" name="my-accordion-3" />
          <div className="collapse-title CustomCardHead CustomAfter  text-[#030021]    ">
            Who is SPONSA for?
          </div>
          <div className="collapse-content bg-[#030021] rounded-[10px]    ">
            <p className="CustomCardPara text-white mt-4">
              Streamers, YouTubers, VTubers, Cosplayers, Artists, you name it.
              If you need multiple tipping goals, SPONSA is for you.
            </p>
          </div>
        </div>
        <div className="collapse collapse-plus bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] px-[3px] pb-[3px] overflow-hidden rounded-[10px] ">
          <input type="checkbox" name="my-accordion-3" />
          <div className="collapse-title CustomCardHead CustomAfter  text-[#030021]    ">
            How do I get paid?
          </div>
          <div className="collapse-content bg-[#030021] rounded-[10px]    ">
            <p className="CustomCardPara text-white mt-4">
              You get paid instantly into your PayPal account! So that means we
              don’t hold onto any of your money - the funds go directly from
              your fans to you.
            </p>
          </div>
        </div>
        <div className="collapse collapse-plus bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] px-[3px] pb-[3px] overflow-hidden rounded-[10px] ">
          <input type="checkbox" name="my-accordion-3" />
          <div className="collapse-title CustomCardHead CustomAfter  text-[#030021]    ">
            How much does it cost?
          </div>
          <div className="collapse-content bg-[#030021] rounded-[10px]    ">
            <p className="CustomCardPara text-white mt-4">
              We take a small 5% service fee from the transaction so our team
              can continue to maintain and improve SPONSA even further. We only
              get paid when you do.
            </p>
          </div>
        </div>
        <div className="collapse collapse-plus bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] px-[3px] pb-[3px] overflow-hidden rounded-[10px] ">
          <input type="checkbox" name="my-accordion-3" />
          <div className="collapse-title CustomCardHead CustomAfter  text-[#030021]    ">
            Do I need a huge following to use SPONSA?
          </div>
          <div className="collapse-content bg-[#030021] rounded-[10px]    ">
            <p className="CustomCardPara text-white mt-4">
              With SPONSA, you can fund your projects and make an income
              regardless of your audience size. Chances are you already have
              dedicated fans eager to support you! We’re here to help connect
              you to them.
            </p>
          </div>
        </div>
        <div className="collapse collapse-plus bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] px-[3px] pb-[3px] overflow-hidden rounded-[10px] ">
          <input type="checkbox" name="my-accordion-3" />
          <div className="collapse-title CustomCardHead CustomAfter  text-[#030021]    ">
            What currencies do you support?
          </div>
          <div className="collapse-content bg-[#030021] rounded-[10px]    ">
            <p className="CustomCardPara text-white mt-4">
              Creators can accept payments in any currency. PayPal will just
              auto-convert the tip into your currency of choice (currently USD
              or GBP, but with more options coming soon!)
            </p>
          </div>
        </div>
        <div className="collapse collapse-plus bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] px-[3px] pb-[3px] overflow-hidden rounded-[10px] ">
          <input type="checkbox" name="my-accordion-3" />
          <div className="collapse-title CustomCardHead CustomAfter  text-[#030021]    ">
            Is SPONSA just a tipping platform?
          </div>
          <div className="collapse-content bg-[#030021] rounded-[10px]    ">
            <p className="CustomCardPara text-white mt-4">
              Currently, yes. Our main goal is to allow content creators to set
              up multiple project goals and receive tips for them all at the
              same time – a feature that no other tipping platform provides.
            </p>
            <p className="CustomCardPara text-white mt-5">
              However, we’re planning on adding tonnes of features as we grow,
              including Membership Tiers, a Donothon Widget and a Mobile App
              (Android and iOS) to name a few!
            </p>
          </div>
        </div>
        <div className="collapse collapse-plus bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] px-[3px] pb-[3px] overflow-hidden rounded-[10px] ">
          <input type="checkbox" name="my-accordion-3" />
          <div className="collapse-title CustomCardHead CustomAfter  text-[#030021]    ">
            How can I get in touch?
          </div>
          <div className="collapse-content bg-[#030021] rounded-[10px]    ">
            <p className="CustomCardPara text-white mt-4">
              Reach out to us on{" "}
              <Link
                to={"https://x.com/SPONSAOfficial"}
                target="_blank"
                className="LinkUnderline"
              >
                Twitter/X
              </Link>{" "}
              or drop us an email:{" "}
              <Link to={"mailto:support@sponsa.app"} className="LinkUnderline">
                support@sponsa.app
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewFaqs;
